import React from 'react';
import PropTypes from 'prop-types';

const PayPal = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 26 31"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M21.57 2.254C20.185.676 17.683 0 14.482 0h-9.29a1.33 1.33 0 0 0-1.314 1.122L.01 25.655a.798.798 0 0 0 .788.922h5.735l1.44-9.136-.044.286a1.326 1.326 0 0 1 1.31-1.122h2.725c5.354 0 9.546-2.175 10.77-8.466.037-.186.068-.367.096-.544-.155-.082-.155-.082 0 0 .364-2.325-.003-3.908-1.26-5.34"
        fill="#27346A"
      />
      <path
        d="M10.168 6.757c.153-.072.324-.113.502-.113h7.284c.862 0 1.667.056 2.402.175a10.093 10.093 0 0 1 1.191.265 6.58 6.58 0 0 1 1.283.511c.364-2.326-.003-3.908-1.26-5.34C20.184.675 17.683 0 14.482 0h-9.29a1.33 1.33 0 0 0-1.314 1.122L.01 25.654a.797.797 0 0 0 .787.922h5.736l2.989-18.95c.06-.39.31-.707.646-.869z"
        fill="#27346A"
      />
      <path
        d="M22.606 8.544c-1.225 6.29-5.417 8.466-10.771 8.466H9.109c-.654 0-1.207.476-1.308 1.122l-1.792 11.36a.698.698 0 0 0 .689.807h4.834c.573 0 1.06-.417 1.149-.982l.047-.246.911-5.775.059-.32c.09-.564.576-.98 1.149-.98h.723c4.684 0 8.35-1.904 9.422-7.407.448-2.3.216-4.22-.967-5.568A4.618 4.618 0 0 0 22.701 8c-.028.178-.059.358-.095.544z"
        fill="#2790C3"
      />
      <path
        d="M21.618 7.44a8.933 8.933 0 0 0-.578-.148 10.918 10.918 0 0 0-.614-.117C19.691 7.056 18.886 7 18.024 7H10.74a1.16 1.16 0 0 0-1.149.982l-1.547 9.815-.045.286a1.324 1.324 0 0 1 1.308-1.122h2.726c5.354 0 9.547-2.175 10.771-8.466.037-.186.067-.366.096-.544a6.613 6.613 0 0 0-1.283-.511"
        fill="#1F264F"
      />
    </g>
  </svg>
);

PayPal.propTypes = {
  className: PropTypes.string,
};

PayPal.defaultProps = {
  className: '',
};

export default PayPal;
